import { GenIcon } from 'react-icons';
export const MdCurrencyFlagJpy = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_34989)' },
            child: [
                {
                    tag: 'rect',
                    attr: {
                        width: '24',
                        height: '24.0005',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M24 11.9577C24 18.6005 18.6139 24.0005 12 24.0005C5.38608 24.0005 0 18.5979 0 11.9577C0 5.80452 4.62232 0.710595 10.5653 0H13.432C19.3777 0.710595 24 5.80452 24 11.9577Z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M17.0859 17.1113C19.8967 14.2906 19.8966 9.71725 17.0859 6.8965C14.2752 4.07576 9.71818 4.07575 6.90747 6.8965C4.09676 9.71724 4.09677 14.2906 6.90747 17.1113C9.71818 19.9321 14.2752 19.9321 17.0859 17.1113Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_34989' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
